import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../services/auth.service';

/**
 * Lee ?access_token=XXX o ?_t=XXX de la URL cuando WordPress redirige al usuario al panel.
 * Almacena el token en memoria + sessionStorage para que la sesión se mantenga tras las actualizaciones de página.
 * Limpia la URL inmediatamente utilizando Location.replaceState() para evitar que el token permanezca en el historial del navegador o en los registros del servidor.
 *
 * Debe aparecer ANTES de authGuard en canActivate para que el token se establezca
 * antes de que authGuard compruebe si la sesión es válida.
 */
export const tokenFromUrlGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const location    = inject(Location);

  const token = route.queryParamMap.get('access_token') || route.queryParamMap.get('_t');

  if (token) {
    authService.setTokenFromExternal(token);

    // Eliminar el token de la URL sin activar una nueva navegación en Angular.
    // Mantener cualquier otro parámetro de consulta que pueda tener la ruta.
    const remainingParams = { ...route.queryParams };
    delete remainingParams['access_token'];
    delete remainingParams['_t'];
    const paramString = new URLSearchParams(remainingParams).toString();
    const cleanPath   = state.url.split('?')[0];
    location.replaceState(cleanPath + (paramString ? '?' + paramString : ''));
  }

  return true;
};
